import { Typography, Tooltip, Stack, colors } from '@ui-components/neo.tax';
import { ReactComponent as WarningTriangle } from '@ui-components/neo.tax/dist/icons/warning-triangle.svg';

interface AscWageNameCellProps {
  name: string;
  hasCompleteDataInPeriod: boolean;
}

export const AscWageNameCell = ({ hasCompleteDataInPeriod, name }: AscWageNameCellProps): React.ReactElement => (
  <Stack direction="row" alignItems="center" gap={2} overflow="hidden">
    <Typography fontWeight="medium" fontSize="inherit" lineHeight="inherit" textOverflow="truncate" title={name}>
      {name}
    </Typography>
    {!hasCompleteDataInPeriod ? (
      <Tooltip text="Cost is missing for some months">
        <WarningTriangle width={16} color={colors.lemon[400]} />
      </Tooltip>
    ) : null}
  </Stack>
);
